import { GENDER_OPTION, GENDER_OPTION_ALL } from '../../../../../ReusableFormFields/GenderFields/fields'

export const GENDER_MALE = 'GENDER_MALE'
export const GENDER_FEMALE = 'GENDER_FEMALE'

export const initialValues = {
  [GENDER_OPTION]: GENDER_OPTION_ALL
}
